import ArticlesPage from "../Pages/articles-page/ArticlesPage";


const articlesRoutes = [
  {
    path: "/agccNews",
    element: <ArticlesPage />
  },

];

export default articlesRoutes;
